/* src/app/components/doc-viewer-new/doc-viewer-bottom-panel/doc-viewer-bottom-panel.component.scss */
:host-context(.dark-theme) .current-tab {
  background: rgb(48, 48, 48);
}
:host-context(.dark-theme) .tab-panel {
  background: #000;
}
:host-context(.dark-theme) .tab-panel-icon {
  color: rgb(255, 193, 7);
}
:host-context(.dark-theme) .settings-icon {
  --fa-primary-color: #8d8d8d;
  --fa-secondary-color: #FFC107;
  --fa-primary-opacity: 1;
  --fa-secondary-opacity: 1;
}
.tab-panel {
  display: flex;
  width: 100%;
  min-height: 50px;
  justify-content: space-between;
  background: #f5f5f5;
}
.current-tab {
  background: #fafafa;
}
.tab-panel-icon {
  font-size: 16px;
  color: rgb(36, 62, 144);
  width: 30px;
}
.tab-panel-expand-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 20px;
  width: 20px !important;
  opacity: 0.5;
  transition: opacity 550ms ease-out, transform 500ms ease-out;
}
.tab-panel-icon-container:hover .tab-panel-expand-icon {
  opacity: 1;
  transform: scale(1.1);
}
.settings-icon {
  --fa-primary-color: rgb(36, 62, 144);
  --fa-secondary-color: rgb(36, 62, 144);
  --fa-primary-opacity: 0.4;
  --fa-secondary-opacity: 1;
}
.panel-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: 500px;
  height: 100%;
  position: relative;
}
.interaction-container {
  flex-grow: 1;
  overflow-y: auto;
  max-height: calc(100% - 30px);
  padding-left: 15px;
  padding-right: 15px;
}
/*# sourceMappingURL=doc-viewer-bottom-panel.component.css.map */
